// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__xAL2U","container__outlet":"dashboard_container__outlet__-p58C","container__outlet__box":"dashboard_container__outlet__box__MEcHh"};